import React from 'react';
import {INav} from 'features/layout/redux/helpers/FoldersHelper';
import {DialogTypes} from 'common/names';
import Dialog from 'components/Dialog';
// import FormikBrowseFileInput from 'components/inputs/FormikBrowseFileInput';
import FormikTextField from 'components/inputs/FormikTextField';
import FormikPassphrase from 'components/inputs/FormikPassphrase';
import Panel from 'components/Panel';
import {FormFooterButtons} from 'components/buttons/FormFooterButtons';
import {useTranslation} from 'react-i18next';
import {
   ImportSSHKeyPair,
   ImportSSHKeyPairNames,
   importSSHKeyPairSchema,
} from 'types/diplomat/keys/ImportSSHKeyPair';
import {useDispatch, useSelector} from 'react-redux';
import selectors from 'features/layout/redux/selectors';
import {folderNames} from 'common/constants';
import {usePostApi} from 'common/hooks/usePostApi';
import api from 'api';
import {castToSend} from 'common/yup/castToSend';
import {layoutActions} from 'features/layout/redux';
import OverwriteConfirmation from 'features/layout/DialogRoutes/dialogs/keys/components/OverwriteConfirmation';
import {useModal} from 'common/hooks/useModal';
import Formik, {FormOnSubmitHelpers} from 'components/hook-form/Formik';

type ImportSshKeyPairProps = {
   onClose: () => void;
   data?: INav;
};

const ImportSshKeyPair = ({data, onClose}: ImportSshKeyPairProps) => {
   const {t} = useTranslation();
   const dispatch = useDispatch();
   const keys = useSelector(selectors.clientSshKeys);
   const defaultFolder = useSelector(selectors.folderByName(folderNames.SSH_KEY_PAIRS));
   const {request} = usePostApi(api.importSSHKeyPair);
   const {open, handleOpen, handleClose} = useModal();
   const onSuccess = () => {
      dispatch(layoutActions.loadTreeNav());
      onClose();
   };

   const [submitProps, setSubmitProps] = React.useState<
      [ImportSSHKeyPair, FormOnSubmitHelpers<ImportSSHKeyPair>]
   >();
   const handleSubmit = (
      values: ImportSSHKeyPair,
      helpers: FormOnSubmitHelpers<ImportSSHKeyPair>
   ) => {
      if (!values.overwrite && keys.some((key) => key.name === values.keyName)) {
         setSubmitProps([values, helpers]);
         handleOpen();
         return;
      }
      request(JSON.stringify(castToSend(importSSHKeyPairSchema, values)), {
         onSuccess,
         helpers,
         onFailure: (e) => {
            helpers.setSubmitting(false);
            helpers.setErrors(e);
         },
      });
   };
   return (
      <Dialog maxWidth="sm" header={DialogTypes.ImportSSHKeyPair.dialogName} close={onClose}>
         <Formik
            enableReinitialize
            initialValues={importSSHKeyPairSchema.cast({folderID: data?.id || defaultFolder?.id})}
            validationSchema={importSSHKeyPairSchema}
            onSubmit={handleSubmit}
         >
            <>
               <OverwriteConfirmation
                  open={open}
                  keyType={t('an SSH key')}
                  keyName={submitProps?.[0].keyName}
                  onOk={() => {
                     handleSubmit({...submitProps![0], overwrite: true}, submitProps![1]);
                     handleClose();
                  }}
                  onCancel={handleClose}
               />
               <Panel>
                  {/* <FormikBrowseFileInput name={'filePath'} label={t('SSH Key File')} /> */}
                  <FormikTextField
                     autoFocus
                     name={ImportSSHKeyPairNames.filePath}
                     label={t('SSH Keypair Body')}
                     multiline
                     rows={8}
                  />
                  <FormikTextField autoFocus name={'keyName'} label={t('Key Name')} />
                  <FormikPassphrase name={'passphrase'} label={t('Key Passphrase')} />
                  <FormikPassphrase name={'existingPassphrase'} label={t('Repeat Passphrase')} />
               </Panel>
               <FormFooterButtons cancel={onClose} />
            </>
         </Formik>
      </Dialog>
   );
};

export default ImportSshKeyPair;
